import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Question } from 'src/app/models/question.model';
import { QuestionnaireStore } from 'src/app/store/questionnaire-store';

@Component({
    selector: 'que-link-display',
    imports: [CommonModule],
    templateUrl: './link-display.component.html',
    styleUrls: ['./link-display.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LinkDisplayComponent {
  @Input()
  question?:Question;
  @Input() viewAnswer = false;
  #questionnaireStore = inject(QuestionnaireStore);
  isUser$ = this.#questionnaireStore.isUser$;

}
